import { getFeedbackAreasForSelection } from './getFeedbackAreasForSelection';
import { FeedbackArea } from '../config/schema/FeedbackAreas';
import { AttachmentDetails } from 'owa-automated-message';

export function getDebugLogAttachmentDetailsForFeedBackAreas(): Promise<AttachmentDetails[]> {
    const blobPromises = getFeedbackAreasForSelection().reduce(
        (result: Promise<AttachmentDetails>[], area: FeedbackArea) => {
            const { getDebugLogAttachmentDetails } = area;
            if (getDebugLogAttachmentDetails) {
                const getDebugInfoRequest = async () =>
                    (await getDebugLogAttachmentDetails.import())();
                result.push(getDebugInfoRequest());
            }
            return result;
        },
        []
    );

    return Promise.all(blobPromises);
}
